export default __webpack_public_path__ + "static/media/with_text_old.21389d7c.png";